var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDateTimeQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.15513 2.61988H11.298V1.19131C11.298 0.718096 11.6801 0.334167 12.1551 0.334167C12.6301 0.334167 13.0123 0.718096 13.0123 1.19131V2.61988H14.4408C15.7016 2.61988 16.7266 3.6431 16.7266 4.9056V16.3342C16.7266 17.5949 15.7016 18.6199 14.4408 18.6199H3.01228C1.74978 18.6199 0.726562 17.5949 0.726562 16.3342V4.9056C0.726562 3.6431 1.74978 2.61988 3.01228 2.61988H4.44085V1.19131C4.44085 0.718096 4.82299 0.334167 5.29799 0.334167C5.77299 0.334167 6.15513 0.718096 6.15513 1.19131V2.61988ZM2.44085 16.3342C2.44085 16.6485 2.69656 16.9056 3.01228 16.9056H14.4408C14.7551 16.9056 15.0123 16.6485 15.0123 16.3342V7.19131H2.44085V16.3342Z",
    fill: "#0E7490"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateTimeQuestion);
export default __webpack_public_path__ + "static/media/date-time-question.22b2cb17b6eed2777faad2e1bd2fecdc.svg";
export { ForwardRef as ReactComponent };